export const LOGIN_ADMIN = '/admin';
export const IS_ADMIN = '/admin/isAdmin';
export const GET_ALL_CRAFTSMAN = '/admin/stores/experts/list';
export const CREATE_STORE = '/admin/stores';
export const GET_STORES = '/admin/stores/all';
export const GET_USER_CREDITS = (userId) => `/store/user/${userId}/credits`;
export const GET_STORE_CRAFTSMAN = (id) => `store/${id}/craftsman`;
export const UPDATE_STORE_CRAFTSMAN = (id) =>
    `/admin/stores/${id}/experts/list`;
export const GET_STORE_DETAILS = (id) => `admin/stores/${id}`;
export const REQUESTS_REQUESTED = (q) => '/admin/requests/requested?' + q;
export const REQUESTS_APPROVED = (q) => '/admin/requests/approved?' + q;
export const REQUESTS_ARCHIVED = (q) => '/admin/requests/archived?' + q;
export const REQUESTS_CANCELED = (q) => '/admin/requests/canceled?' + q;

export const CRAFTSMAN_PENDING = (q) => '/admin/craftsmen/pending?' + q;
export const CRAFTSMAN_BLOCKED = (q) => '/admin/craftsmen/blocked?' + q;
export const CRAFTSMAN_APPROVED = (q) => '/admin/craftsmen/approved?' + q;

export const CLIENTS_ACTIVE = (q) => '/admin/clients/active?' + q;
export const CLIENTS_BLOCKED = (q) => '/admin/clients/blocked?' + q;

export const GET_CLIENT_BY_ID = (id) => `/admin/client/${id}`;
export const GET_CRAFTSMAN_BY_ID = (id) => `/admin/craftsman/${id}`;

export const BLOCK_CLIENT = (id) => `/admin/client/${id}/block`;
export const UNBLOCK_CLIENT = (id) => `/admin/client/${id}/unblock`;

export const BLOCK_CRAFTSMAN = (id) => `/admin/craftsman/${id}/block`;
export const UNBLOCK_CRAFTSMAN = (id) => `/admin/craftsman/${id}/unblock`;

export const GET_REQUEST_BY_ID = (id) => `/admin/request/${id}`;

export const DOWNLOAD_FILE = (filename) => `/file/downloadByName/${filename}`;

export const CONSULTATIONS_FOR_REQUEST = (id) => `/consultation/${id}`;
export const GET_CREDITS_HISTORY = (userId) => `/export/user/${userId}/credits`;

export const DELETE_USER = (id) => `/client/${id}`;
export const DELETE_CRAFTSMAN = (id) => `/craftsman/${id}`;

export const CHATS = `/admin`;
